import { render, staticRenderFns } from "./RoofCalQuest.vue?vue&type=template&id=27064db7&scoped=true"
import script from "./RoofCalQuest.vue?vue&type=script&lang=js"
export * from "./RoofCalQuest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27064db7",
  null
  
)

export default component.exports